"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceRemovalPayload = exports.UserAppRemovalPayload = exports.UserRemovalPayload = exports.DeviceUpsertPayload = exports.UserAppUpsertPayload = exports.UserUpsertPayload = exports.DeviceQuery = exports.UserAppQuery = exports.UserQuery = exports.Items = exports.KeyValueItem = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Metadata.Schema';
const nonEmpty = (description) => effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString.annotations({ description })).annotations({ description });
const optionalString = (description) => effect_1.Schema.optionalWith(effect_1.Schema.String.annotations({ description }), { exact: true }).annotations({
    description,
});
const filters = optionalString('Comma-separated keys to return. Runtime keeps a key only when the stored value is truthy.');
/**
 * Device identity on POST/DELETE and the Svix webhook. Each express-validator
 * rule applies only when the other field is absent, so at least one is
 * required and supplying both is accepted (and then neither is checked for
 * type or length). The runtime reads
 * `deviceSerialNumber || manufacturingSerialNumber`, then falls back to a
 * manufacturing-serial lookup. GET does not use this: it looks up by id only.
 * Both stay optional here because JSON Schema cannot express "at least one".
 */
const deviceIdentity = {
    deviceSerialNumber: optionalString('Device serial number (required unless manufacturingSerialNumber is set; min 2 characters). Takes precedence when both are supplied.'),
    manufacturingSerialNumber: optionalString('Manufacturing serial number (required unless deviceSerialNumber is set)'),
};
exports.KeyValueItem = effect_1.Schema.Struct({
    key: nonEmpty('Metadata key'),
    value: effect_1.Schema.propertySignature(Json.Value).annotations({
        description: 'Metadata value; stored as-is',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.KeyValueItem`,
    description: 'One metadata key/value pair for POST items',
});
const items = effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyArray(exports.KeyValueItem)).annotations({
    description: 'Metadata pairs to merge or overwrite (min 1)',
});
const removalKeys = effect_1.Schema.optionalWith(effect_1.Schema.Array(effect_1.Schema.String), { exact: true }).annotations({
    description: 'Keys to remove. Omitted or empty clears all metadata for the owner.',
});
exports.Items = effect_1.Schema.Struct({
    items: effect_1.Schema.propertySignature(Json.Record).annotations({
        description: 'Stored metadata map, not an array of key/value pairs',
    }),
}).annotations({
    identifier: `${exports.NAMESPACE}.Items`,
    description: 'GET success data. Missing owner currently yields 200 with {}. The controller 404 branch is dead on every routed request: the router hardcodes ownerType, and get() always returns an object for those three cases.',
});
exports.UserQuery = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    filters,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserQuery`,
    description: 'Query parameters for shared user metadata',
});
exports.UserAppQuery = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    appId: nonEmpty('Client application id'),
    filters,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserAppQuery`,
    description: 'Query parameters for per-application user metadata',
});
exports.DeviceQuery = effect_1.Schema.Struct({
    deviceSerialNumber: optionalString('Device id to look up (required unless manufacturingSerialNumber is set; min 2 characters). Takes precedence when both are supplied.'),
    manufacturingSerialNumber: optionalString('Accepted when deviceSerialNumber is absent, but GET looks devices up by id only. An MSN-only query returns items {} even when that manufacturing serial exists.'),
    filters,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceQuery`,
    description: 'Query parameters for device metadata. Lookup is by device id, not manufacturing serial.',
});
exports.UserUpsertPayload = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    items,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserUpsertPayload`,
    description: 'Add or overwrite shared user metadata. ownerType is injected by the router.',
});
exports.UserAppUpsertPayload = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    appId: nonEmpty('Client application id'),
    items,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserAppUpsertPayload`,
    description: 'Add or overwrite per-app user metadata. ownerType is injected by the router.',
});
exports.DeviceUpsertPayload = effect_1.Schema.Struct({
    ...deviceIdentity,
    uuid: optionalString('Svix event uuid; used when acknowledging inventory updates'),
    items,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceUpsertPayload`,
    description: 'Add or overwrite device metadata. ownerType is injected by the router.',
});
exports.UserRemovalPayload = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    items: removalKeys,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserRemovalPayload`,
    description: 'Remove shared user metadata keys, or all keys when items is omitted.',
});
exports.UserAppRemovalPayload = effect_1.Schema.Struct({
    userId: nonEmpty('User id'),
    appId: nonEmpty('Client application id'),
    items: removalKeys,
}).annotations({
    identifier: `${exports.NAMESPACE}.UserAppRemovalPayload`,
    description: 'Remove per-app user metadata keys, or all keys when items is omitted.',
});
exports.DeviceRemovalPayload = effect_1.Schema.Struct({
    ...deviceIdentity,
    items: removalKeys,
}).annotations({
    identifier: `${exports.NAMESPACE}.DeviceRemovalPayload`,
    description: 'Remove device metadata keys, or all keys when items is omitted.',
});
//# sourceMappingURL=schema.js.map